import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 使用vue3 UI 库
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './locales'
import { localePath } from './utils/locale'

const app = createApp(App)
app.use(ElementPlus).use(store).use(router).use(i18n)
// 供 Options API 组件模板使用：$lp('/news') → 当前语言下带 /en 前缀的路径
app.config.globalProperties.$lp = (p) => localePath(p, i18n.global.locale.value)
app.mount('#app')
